module.exports = __webpack_public_path__ + "assets/img/home2-box2-1.64dd480e.png";